import {MolecularGraph} from "../../graph/MolecularGraph"
import {Feature, Features} from "../../feature";
import {extractorUtil} from "../../util/extractorUtil";

export const alkineExtractor = {
    extract: (graph: MolecularGraph) => {
        const carbons = extractorUtil.getFunctionalGroupRootsWithElement("C", graph);
        // Check each carbon for a double bond with another carbon.
        const features: Feature[] = [];
        while(carbons.length > 0) {
            // Get the top carbon and check it for a double bond.
            const curr = carbons.pop()!;
            const doubleCs = graph
                .getBondsAttachedTo(curr)
                .filter(b => b.order === 3 && b.getOtherAtom(curr).symbol === "C");
            doubleCs.forEach(b => {
                // Make a new feature
                const partner = b.getOtherAtom(curr);

                // Find the R groups attached to the atoms
                const a = [curr, partner];
                const r = [curr, partner];

                const feature: Feature = {
                    name: Features.alkine,
                    atoms: a,
                    connections: r
                }
                features.push(feature);

                // remove the partner from the list so we don't get repeats.
                const idx = carbons.indexOf(partner);
                if(idx >= 0) {
                    carbons.splice(idx, 1);
                }
            })
        }
        return features;
    }
}
